module.exports = "<p>\n  admin-custom-nav-link-list works!\n</p>\n"